import type { Core } from 'cytoscape';
import type { OverlayCanvas } from './overlay-canvas';
import type { MaporiumGridOptions } from './options';
import { AlignmentMatch, Box, centreOf } from './snap-geometry';

const LINE_OVERSHOOT = 6;

export function drawGuides(
  cy: Core,
  overlay: OverlayCanvas,
  options: MaporiumGridOptions,
  box: Box,
  matchX: AlignmentMatch | null,
  matchY: AlignmentMatch | null
): void {
  overlay.sync();
  overlay.clear();

  if (!matchX && !matchY) {
    return;
  }

  const zoom = cy.zoom();
  const pan = cy.pan();
  const centre = centreOf(box);
  const { ctx } = overlay;

  ctx.save();
  ctx.strokeStyle = options.guidelinesStyle.strokeStyle;
  ctx.lineWidth = options.guidelinesStyle.lineWidth;
  ctx.setLineDash(options.guidelinesStyle.lineDash);
  ctx.beginPath();

  if (matchX) {
    const x = matchX.line * zoom + pan.x;
    const from = centre.y * zoom + pan.y;
    const to = matchX.cross * zoom + pan.y;
    ctx.moveTo(x, Math.min(from, to) - LINE_OVERSHOOT);
    ctx.lineTo(x, Math.max(from, to) + LINE_OVERSHOOT);
  }

  if (matchY) {
    const y = matchY.line * zoom + pan.y;
    const from = centre.x * zoom + pan.x;
    const to = matchY.cross * zoom + pan.x;
    ctx.moveTo(Math.min(from, to) - LINE_OVERSHOOT, y);
    ctx.lineTo(Math.max(from, to) + LINE_OVERSHOOT, y);
  }

  ctx.stroke();
  ctx.restore();
}
